import { render, staticRenderFns } from "./InstrumentIndex.vue?vue&type=template&id=23fd758e"
import script from "./InstrumentIndex.vue?vue&type=script&lang=js"
export * from "./InstrumentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports